module.exports = __webpack_public_path__ + "static/media/ArtworkJ3InfoDetail2568.0d83ed7c.png";